<template>
  <ul class="tokens">
    <li class="count" :class="[team]">
      {{ getTeamRoleCount(teamRoles) }} /
      {{ compositionCount }}
    </li>
    <RoleSelectionToken v-for="role in teamRoles" :key="role?.id" :role="role" :multiple-allowed="multipleAllowed"
      @toggle="toggleRoleSelection" @increment="incrementRoleSelection" @decrement="decrementRoleSelection" />
  </ul>
</template>

<script setup lang="ts">
import { RoleSelectionToken } from "@/components";
import type { SelectableRole } from "@/types";

defineProps<{
  team: string;
  teamRoles: SelectableRole[];
  compositionCount?: number | undefined;
  multipleAllowed?: boolean | undefined;
}>();

const getTeamRoleCount = (teamRoles: SelectableRole[]) => {
  return teamRoles.reduce((a: number, { selected }) => a + selected, 0);
};

const toggleRoleSelection = (role: SelectableRole) => {
  role.selected = role?.selected ? 0 : 1;
};

const incrementRoleSelection = (role: SelectableRole) => {
  role.selected++;
};

const decrementRoleSelection = (role: SelectableRole) => {
  role.selected--;
};
</script>

<style lang="scss" scoped>
@use "../../vars.scss" as *;

ul.tokens {
  padding-left: 8vmin;
  margin-top: 5px;

  li {
    border-radius: 50%;
    width: 5vmax;
    margin: 5px;
    transition: transform 250ms;
    will-change: transform;

    &.townsfolk {
      box-shadow:
        0 0 10px var(--townsfolk),
        0 0 10px #004cff;
    }

    &.outsider {
      box-shadow: 0 0 10px var(--outsider);
    }

    &.minion {
      box-shadow: 0 0 10px var(--minion);
    }

    &.demon {
      box-shadow: 0 0 10px var(--demon);
    }

    &.traveler {
      box-shadow: 0 0 10px var(--traveler);
    }

    &.fabled {
      box-shadow: 0 0 10px var(--fabled);
    }

    &.loric {
      box-shadow: 0 0 10px var(--loric);
    }

    &:hover {
      transform: scale(1.2);
      z-index: 10;
    }
  }

  .count {
    opacity: 1;
    position: absolute;
    left: 0;
    font-weight: bold;
    font-size: 75%;
    width: 5%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:after {
      content: " ";
      display: block;
      padding-top: 100%;
    }

    &.townsfolk {
      color: var(--townsfolk);
    }

    &.outsider {
      color: var(--outsider);
    }

    &.minion {
      color: var(--minion);
    }

    &.demon {
      color: var(--demon);
    }
  }
}
</style>
